import React from "react";
import "./Footer.css";
import { useState } from "react";
import { appVersion } from "../../version";

const FooterComponent = () => {
  return (
    <div class="footer-txt">
      Copyright &copy; 2024 All rights reserved. <br />
      Powered by UPlayIndia Payments Pvt Ltd. {appVersion}
    </div>
  );
};

export default FooterComponent;
